<template>
  <div class="home">
    <!-- 顶部搜索 -->
    <SearchBar :bgType="headbgType" :bg="headerBg" :info="searchInfo"/>
     <!-- 首页背景 -->
    <div class="home-bg-color" :style="{'background': headerBg, 'background-size': bgSize}"></div>
    <div id="bgBody" class="home-bg-body" :style="{'background': bodyBgColor, 'background-size': bgSize}"></div>
    <!-- 首页主体 -->
    <div class="home-warp">
      <div class="home-body">

          <!-- banner swiper -->
          <div class="home-banner">
            <van-swipe :autoplay="3000" indicator-color="white" class="banner" @change="swiperChange">
              <van-swipe-item v-for="(item, index) in bannerList" :key="index">

              </van-swipe-item>
            </van-swipe>
          </div>

          <!-- 分类 -->
          <category-items :bgColor="categoryBgColor" :items="categorys"/>

          <!-- 中通广告 -->
          <div class="middle-adv" v-if="middleAdbanner">
            <vanImg :src="middleAdbanner.iconUrl" alt="" />
          </div>

          <!-- 金刚区 -->
          <kingKong :items="kingkongs"/>

          <div id="btmWarp" class="home-btm-warp" :style="{'background': bottomColor}">
              <img src="./preview.png">
          </div>

      </div>
    </div>

  </div>
</template>

<script>
import SearchBar from './components/topsearchbar'
import categoryItems from './components/categoryitems'
import kingKong from './components/kingkong'

import Api from './api';

export default {
  name: 'homepreview',
  components: {
    SearchBar,
    categoryItems,
    kingKong,
  },
  data() {
    return {
      activitid: '', // 活动配置id

      headerBgsetdefault: '',

      isHeaderBgBySwiper: false, // 头部背景是否跟随 swiper banner
      // barOpacity: 0,
      headerBg: '#2878FF linear-gradient(to right, rgba(40,120,255,1), rgba(51,127,255,0))', // 头部背景色  blue  red,1  blue,0
      // headerBg: 'blue linear-gradient(to right, rgba(255,0,0,1), rgba(0,0,255,0))',
      // headerBg: 'url(https://sg-file-test.oss-cn-beijing.aliyuncs.com/mobilemall-admin-web/bannercontroller/image/2020/07/13b90c66de4a49058df15b2697d07e11.jpg) center top no-repeat',
      bodyBgColor: '',
      bottomColor: '', // 底部主体背景

      headbgType: 2, // 背景类型  1跟随banner  2背景色  3背景图  4左右渐变  5上下渐变  6透明
      bgSize: '100% 100%',

      searchInfo: {
        words: ['千万商品中搜索'],
        logo: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/logo.png',
        kefu: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/kefu.png',
        cart: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/cart.png',
        cartnum: '',
        more: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/menu.png'
      },
      isLoading: true,

      bannerList: [], // banner

      middleAdbanner: null, // 中通图banner

      categorys: [
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/01.png', name: '冰箱' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/02.png', name: '洗衣机' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/03.png', name: '空调' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/04.png', name: '热水器' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/05.png', name: '电视' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/06.png', name: '厨房大电' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/07.png', name: '生活电器' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/08.png', name: '家具家装' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/09.png', name: '智能产品' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/10.png', name: '更多' },
      ], // 分类
      categoryBgColor: '#fff', // 分类部分背景色

      kingkongs: [
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/k_01.png', name: '领券中心', linkUrl: '/voucher' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/k_02.png', name: '分期购', linkUrl: '/banner/554' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/k_03.png', name: '海尔智选', linkUrl: '/specialtyStore' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/k_04.png', name: '场景超市', linkUrl: '/scene' },
        // {iconUrl: require('@/assets/images/new/k_05.png'), name: '每日榜单', linkUrl: '/voucher'},
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/k_05.png', name: '直播广场', linkUrl: 'https://uplus.haier.com/uplusapp/weihou/index.html?tabType=live' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/k_06.png', name: '智家魔方', linkUrl: '/banner/1971' },
      ], // 金刚区

      // couponList: [], // 优惠券

      // bangData: [], // 榜单

      // programTabs: [], // 场景超市tab
      // programLists: {}, // 场景超市数据

      // productRemmond: [], // 必选单品
      // electricalGoods: {
      //   one: '',
      //   two: '',
      //   three: ''
      // }, // 生态优选

      // findGoodsInfo: {}, // 发现好货
      // countTime: 0, // 倒计时

      // nearbyList: [], // 附近店铺

      // showTotop: false, // 回到顶部
    }
  },
  mounted() {
    this.init()
  },

  methods: {
    init() {
      this.onRefresh();
    },

    onRefresh () {
      Api.getActivitidInfo({
        id: this.$route.query.id
      }).then(res => {
        let result = res.data;
        console.log(result, '++++ res ++++')
        this.categorys = result.data.categoryList.splice(0, 10)
        // this.categoryBgColor =

        let searchInfo = result.data.navigationList;
        searchInfo && searchInfo.forEach((item, index) => {
          if (item.position === 1) {
            this.searchInfo.logo = item.iconUrl
          }
          if (item.position === 2) {
            this.searchInfo.kefu = item.iconUrl
          }
          if (item.position === 3) {
            this.searchInfo.cart = item.iconUrl
          }
          if (item.position === 4) {
            this.searchInfo.more = item.iconUrl
          }
        })

        this.kingkongs = result.data.vajraList

        let bgInfo = result.data.backgroundList || [];
        let bgInfoJson = {}

        bgInfo.forEach(item => {
          if (item.position === 1) {
            bgInfoJson['head_bg'] = item
          }
          if (item.position === 2) {
            bgInfoJson['middle_bg'] = item
          }
          if (item.position === 3) {
            bgInfoJson['keyword_bg'] = item
          }
          if (item.position === 4) {
            bgInfoJson['bottom_bg'] = item
          }
        })

        // key-value 映射表
        const mapJson = {
          'head_bg': 'headerBg',
          'keyword_bg': 'categoryBgColor',
          'middle_bg': 'bodyBgColor',
          'bottom_bg': 'bottomColor',
        }

        // console.log(bgInfoJson, 'bgInfo')
        Object.keys(bgInfoJson).forEach(item => {
          let value = bgInfoJson[item];
          console.log(value, item)
          if (item === 'head_bg') {
            value.enableBanner === 1 ? this.isHeaderBgBySwiper = true : this.isHeaderBgBySwiper = false
            this.headerBgsetdefault = value; // banner 切换时 存储当前头部默认设置防止 banner 背景没配
            this.headbgType = value.backgroundType
            if (value.enableBanner === 1 && this.bannerList.length && this.bannerList[0].backgroudColor) { // 主题跟随banner设置变化
              this[mapJson[item]] = this.bannerList[0].backgroudColor
            } else if (value.backgroundType === 2) { // 主题设置为背景色值
              this[mapJson[item]] = value.background
            } else if (value.backgroundType === 3) { // 主题设置背景图
              this[mapJson[item]] = `url(${value.background}) center top no-repeat`
              this.bgSize = '100% auto'
            } else if (value.backgroundType === 4) { // 主题设置左右渐变
              let colors = value.background.split(',')
              this[mapJson[item]] = `${colors[1]} linear-gradient(to right, ${this.hexToRgba(colors[0], 1)}, ${this.hexToRgba(colors[1], 0)})`
              this.bgSize = '100% 100%'
            } else if (value.backgroundType === 5) {
              let colors = value.background.split(',')
              this[mapJson[item]] = `${colors[1]} linear-gradient(to bottom, ${this.hexToRgba(colors[0], 1)}, ${this.hexToRgba(colors[1], 0)})`
              this.bgSize = '100% 100%'
            } else if (value.backgroundType === 6) {
              this[mapJson[item]] = 'transparent'
            }
          } else {
            if (value.backgroundType === 2) { // 设置为背景色值
              this[mapJson[item]] = value.background
            } else if (value.backgroundType === 3) { // 设置背景图
              this[mapJson[item]] = `url(${value.background}) center top no-repeat`
              this.bgSize = '100% auto'
            } else if (value.backgroundType === 4) { // 设置背景渐变
              let colors = value.background.split(',')
              this[mapJson[item]] = `linear-gradient(to right, ${colors[0]}, ${colors[1]})`
              this.bgSize = '100% 100%'
            } else if (value.backgroundType === 5) { // 设置背景渐变
              let colors = value.background.split(',')
              this[mapJson[item]] = `linear-gradient(to bottom, ${colors[0]}, ${colors[1]})`
              this.bgSize = '100% 100%'
            } else if (value.backgroundType === 6) {
              this[mapJson[item]] = 'transparent'
            }
          }
        })
      })
    },

    /**
     * 十六进制颜色转rgba
     */
    hexToRgba(hex, opacity) {
      return 'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) + ',' +
              parseInt('0x' + hex.slice(5, 7)) + ',' + opacity + ')';
    },
    /**
     * swiper change
     */
    swiperChange(index) {
      if (this.isHeaderBgBySwiper && !this.isFixed) {
        if (this.bannerList[index].backgroudColor) {
          this.headerBg = this.bannerList[index].backgroudColor
        } else {
          let value = this.headerBgsetdefault
          console.log(value, 'old')
          if (value.backgroundType === 2) { // 主题设置为背景色值
            this.headerBg = value.background
          } else if (value.backgroundType === 3) { // 主题设置背景图
            this.headerBg = `url(${value.background}) center top no-repeat`
          } else if (value.backgroundType === 4) { // 主题设置左右渐变
            let colors = value.background.split(',')
            this.headerBg = `${colors[1]} linear-gradient(to right, ${this.hexToRgba(colors[0], 1)}, ${this.hexToRgba(colors[1], 0)})`
          } else if (value.backgroundType === 5) {
            let colors = value.background.split(',')
            this.headerBg = `${colors[1]} linear-gradient(to bottom, ${this.hexToRgba(colors[0], 1)}, ${this.hexToRgba(colors[1], 0)})`
          } else if (value.backgroundType === 6) {
            this.headerBg = 'transparent'
          }
        }
        // 如果渐变用注释部分
        // this.headerBg = `${this.bannerList[index].backgroudColor} linear-gradient(to right, ${this.hexToRgba(this.bannerList[index].backgroudColor,1)}, ${this.hexToRgba(this.bannerList[index].backgroudColor,0)})`
      }
    },

  }
}
</script>

<style lang="scss" scoped>

.home{
  position: relative;
}

.home-bg-color{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2.48rem;
  border-radius: 0 0 7.5rem 7.5rem/1.24rem;
  z-index: 2;
  transition: background-color 1s;
  box-sizing: content-box;
}
.home-bg-body{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 11.5rem;
  z-index: 1;
}
.home-warp{
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
  box-sizing: border-box;
}

.home-banner{
  margin: .24rem;
  margin-top: .16rem;
  height: 2.8rem;
  overflow: hidden;
  border-radius: .24rem;
  background: #fff;
}
.banner{
  height: 2.8rem;
  overflow: hidden;
  border-radius: .24rem;
  img{
    width: 100%;
    height: 100%;
    transform: translateZ(0);
    will-change: auto;
  }
}

.middle-adv{
  margin: .24rem;
  img{
    width: 100%;
  }
}

.home-btm-warp{
  height: 24rem;
  padding-bottom: 1rem;
  overflow: hidden;
  img{
    width: 100%;
  }
}

</style>
